import SubscriptionManagement from './SubscriptionManagement';

export default SubscriptionManagement;
